const gridItems = [...document.querySelectorAll('.grid > .grid__item')];


    gridItems.forEach(item => {
        const image = item.querySelector('.grid__item-img');
        gsap.timeline({
            scrollTrigger: {
                trigger: item,
                start: "0 top",
                end: "bottom top",
                scrub: true
            }
        })
            .set(image, {
                transformOrigin: `${gsap.utils.random(0,1) > 0.5 ? 0 : 100}% 100%`
            })
            .to(image, {
                ease: 'none',
                scale: 0
            });

    });


